<h2 mat-dialog-title> {{ 'generic.confirm_question' | translate }} </h2>
<mat-dialog-content>
 	<div fxLayout="row">
	 	<div fxFlex = "5">
			<mat-icon class="quiet_big_font" [ngStyle] = "icon.style"> {{ icon.icon }} </mat-icon>
		</div>
        <div fxFlex = "94" fxFlexOffset="1" [innerHTML]="custom_message">
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions align="center">
	<button mat-raised-button color="primary" (click)="onConfirmClick()" tabindex="1"> 	{{ 'generic.submit' | translate }} </button>
	<button mat-raised-button mat-dialog-close tabindex="-1">	{{ 'generic.abort' | translate }} </button>
</mat-dialog-actions>
